import React from 'react'

export default class IconLogoDigitalOcean extends React.Component {

    render() {
        let color = "#C8C5FE";
        if (this.props.color) color = this.props.color;
        let className = "icons-icon";

        return <svg className={className} style={this.props.style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="6" fill="white" />
            <g clipPath="url(#clip0_391_40377)">
                <path d="M12.0001 18.1368V21.9999C18.5479 21.9999 23.646 15.6742 21.5041 8.8129C20.5681 5.81445 18.1855 3.43189 15.1871 2.49588C8.32575 0.353954 2 5.45225 2 12H5.87197C5.87254 12 5.87299 11.999 5.87299 11.999C5.87356 7.88981 9.94025 4.71287 14.2605 6.28053C15.861 6.86137 17.1377 8.13782 17.7189 9.73825C19.2868 14.056 16.1146 18.121 12.0089 18.1269V14.2762C12.0089 14.2762 12.0086 14.276 12.0082 14.276H8.14816C8.14782 14.276 8.14748 14.2766 8.14748 14.2766V18.1368H12.0001ZM8.1468 21.1037H5.18091L5.18023 21.103V18.1368H8.14748V21.103C8.14748 21.103 8.14714 21.1037 8.1468 21.1037ZM5.18227 18.1368H2.69594C2.69492 18.1368 2.69413 18.1361 2.69413 18.1361V15.6509C2.69413 15.6509 2.69492 15.6491 2.69594 15.6491H5.18045C5.18147 15.6491 5.18227 15.6499 5.18227 15.6499V18.1368Z" fill="#0080FF" />
            </g>
            <defs>
                <clipPath id="clip0_391_40377">
                    <rect width="20" height="20" fill="white" transform="translate(2 2)" />
                </clipPath>
            </defs>
        </svg>
    }
}    
